import { useEffect } from "preact/hooks";
import { AppTime, AppTimeUnit } from "~/core";
import { AppTimeOptions } from "./interfaces";

const useAppTime = (
    unit: AppTimeUnit,
    { skip = false }: AppTimeOptions = {},
) => {
    const signal = AppTime.signals[unit];

    useEffect(() => {
        if (skip) {
            return;
        }

        AppTime.track(unit);

        return () => AppTime.untrack(unit);
    }, [unit, skip]);

    return signal;
};

export default useAppTime;
